import {selectSeo} from 'coreStore/data/page';
import {useSelector} from 'react-redux';
import {useVersioned} from 'coreUtils/adapters/versioned';
import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';

export const SEO_DATA_KEY = 'seo-data';

const useSeo = () => {
	const {managerRepository} = useGeneralProvider();

	const seo = useSelector(selectSeo);

	return useVersioned(managerRepository.getSeoMgr(), seo);
};

export default useSeo;
